import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=451d236f"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports